import React, { ReactNode, useState } from "react";
import AdminNavbar from "../navbars/AdminNavbar";

const AdminLayout = ({ children }: { children: ReactNode }) => {
  // eslint-disable-next-line
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors duration-300">
      <AdminNavbar />
      <main
        className={`transition-all duration-300 min-h-[calc(100vh-4rem)] pt-16 ${
          sidebarOpen ? "lg:ml-64" : "lg:ml-20"
        }`}
      >
        <div className="p-4 lg:p-6">{children}</div>
      </main>
    </div>
  );
};

export default AdminLayout;
